import {
  FOURTH_FIFTH_THEME_GRADES,
  K1_THEME_GRADES,
  MIDDLE_SCHOOL_THEME_GRADES,
} from 'src/constants/theme.constants';
import { GRADES } from 'src/interfaces/grades.types';
import { Theme } from 'src/interfaces/theme.types';

export const getTheme = (
  grade?: GRADES,
  isMiddleSchoolView?: boolean,
): Theme => {
  const isMiddleSchoolUser = MIDDLE_SCHOOL_THEME_GRADES.includes(
    grade as GRADES,
  );

  if (isMiddleSchoolUser || isMiddleSchoolView) {
    return Theme.MIDDLE_SCHOOL;
  }

  if (K1_THEME_GRADES.includes(grade as GRADES)) {
    return Theme.K1;
  }

  if (FOURTH_FIFTH_THEME_GRADES.includes(grade as GRADES)) {
    return Theme.FOURTH_FIFTH;
  }

  return Theme.SECOND_THIRD;
};
